import { selectLocalizedField } from '@/libs/i18n/currentLocale'

export const settingsMixins = {
  data() {
    return {
      settingsResult: [],
      helptext: [],
      copySettingsResult: [],
      settingsLoaded: false,
    }
  },
  computed: {
    sendMethods() {
      return this.$t('SettingPageCard.sendMethods')
    },
    sendMethodsNox() {
      return this.$t('SettingPageCard.sendMethodsNox')
    },
    messageLang() {
      return selectLocalizedField(this.$i18n, 'message', 'eng_message')
    },
    textLang() {
      return selectLocalizedField(this.$i18n, 'swedish_text', 'english_text')
    },
  },
  methods: {
    async getListHelpText() {
      try {
        const res = await this.$useJwt.listHelpText({
          params: { dashboard_page: 'configuration' },
        })
        const { results } = res.data || {}
        this.helptext = Array.isArray(results) ? results : []
      } catch (e) {
        this.helptext = []
        // Fail-soft: help texts are optional for rendering
      }
    },
    renderCriteria(params) {
      return this.$t('SettingPageCard.criteria').find(
        element => element.value == params,
      )
    },

    renderSendMethods(params) {
      return this.$t('SettingPageCard.sendMethods').find(
        element => element.value == params,
      )
    },

    renderNoxMethods(params) {
      return this.$t('SettingPageCard.sendMethodsNox').find(
        element => element.value == params,
      )
    },

    renderText(field) {
      const item = Array.isArray(this.helptext)
        ? this.helptext.find(element => element.field == field)
        : null
      return item ? item[this.textLang] : ''
    },

    getConfiguration() {
      this.settingsLoaded = false
      const buildDefault = () => {
        const defaultElement = {
          uuid: null,
          auto_bookkeep: false,
          auto_send_regular: false,
          auto_send_nox: false,
          use_print_service_for_print: false,
          regular_send_method: null,
          nox_send_method: null,
          days_back_in_time: 0,
          start_date: new Date().toISOString().slice(0, 10),
          upgrade_option: 'auto_upgrade',
          send_regular_criteria: [],
          send_nox_criteria: [],
        }
        this.settingsResult = [
          {
            ...defaultElement,
            send_regular_criteria: [],
            send_nox_criteria: [],
            regularSendValue: this.renderSendMethods(
              defaultElement.regular_send_method,
            ),
            sendNoxValue: this.renderNoxMethods(
              defaultElement.nox_send_method,
            ),
          },
        ]
        this.copySettingsResult = [{ ...defaultElement }]
      }

      this.$useJwt
        .configure()
        .then(res => {
          const { results } = res.data || {}
          if (!Array.isArray(results) || results.length === 0) {
            buildDefault()
            return
          }

          results.forEach(element => {
            this.settingsResult = [
              {
                ...element,
                send_regular_criteria: (element.send_regular_criteria || []).map(
                  criteria => ({
                    ...criteria,
                    criteriaValue: this.renderCriteria(
                      criteria.criteria_field,
                    ),
                  }),
                ),
                send_nox_criteria: (element.send_nox_criteria || []).map(
                  criteria => ({
                    ...criteria,
                    criteriaValue: this.renderCriteria(
                      criteria.criteria_field,
                    ),
                  }),
                ),
                regularSendValue: this.renderSendMethods(
                  element.regular_send_method,
                ),
                sendNoxValue: this.renderNoxMethods(
                  element.nox_send_method,
                ),
              },
            ]

            this.copySettingsResult = [{ ...element }]
          })
        })
        .catch(() => {
          buildDefault()
        })
        .finally(() => {
          this.settingsLoaded = true
        })
    },
  },
  async mounted() {
    // Don't block rendering on help text; load it in background
    this.getListHelpText()
    this.getConfiguration()
  },
}
